<app-document-subheader/>
<div class="details-content container-fluid h-100">
  <div class="row h-100">
    <div class="col-content d-flex flex-column h-100">
      @if (this.chequeRemittanceModel$ | async; as chequeRemittanceModel) {
        <div class="page-container">
          <div class="card card-light w-100">
            <div class="card-body">
              <div class="container-fluid">
                <div class="row">
                  <div class="col-6 col-lg-6">
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate>CHEQUE_REMITTANCE_LBL_SALES_TEAM_ACCOUNT</label>
                      <div class="col">
                        <span class="form-control-plaintext form-control-sm">
                          {{ chequeRemittanceModel.salesTeamAccountName }}
                        </span>
                      </div>
                    </div>
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate>CHEQUE_REMITTANCE_LBL_BANK_ACCOUNT</label>
                      <div class="col">
                        <span class="form-control-plaintext form-control-sm">
                          {{ chequeRemittanceModel.bankAccountIban }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="form-group row">
                      <label class="col-4 col-form-label-sm" translate>CHEQUE_REMITTANCE_LBL_DELIVERY_DATE</label>
                      <div class="col">
                        <span class="form-control-plaintext form-control-sm">
                          {{ chequeRemittanceModel.deliveryDate |toLocalTime : "dd/MM/yyyy" }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <app-cheque-remittance-tabs-details />
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    @if (this.chequeRemittanceModel$ | async; as chequeRemittanceModel) {
      <div class="col-comment">
        <app-comment-panel
          [entityType]="'ChequeRemittance'"
          [entityId]="chequeRemittanceModel.id.toString()"
        ></app-comment-panel>
      </div>
    }
  </div>
</div>
